export default function() {

  const cookies = document.cookie.split(';');

  const regionCookie = cookies.map(c => c.trim()).find(c => c.startsWith('chosenRegion'))?.split('=');

  return regionCookie && regionCookie[1];
};
